export const CHANGE_PARTICIPANTS_SORT = "scavr/Participants/CHANGE_SORT";
